import { kycSelectorsFactory } from 'state/secondaryMarket/shared/kyc/kyc.selector';

export const limitOrderKycSelectors = kycSelectorsFactory('limitOrder');
